import { Coin } from 'models/Coin';
import * as yup from 'yup';

export interface EventValues {
    type: string;
    title: string;
    description: string;
    date: Date;
    public: boolean;
    tickets: number | null;
    price: number;
    pricingEnabled: boolean;
    nftCollections: string[];
    coins: Coin[];
}

const currentDate = new Date();
currentDate.setMinutes((Math.round(currentDate.getMinutes() / 15) * 15) % 60);

export const eventFormInitialValues: EventValues = {
    type: 'Interactive',
    title: '',
    description: '',
    date: currentDate,
    public: true,
    tickets: 0,
    price: 0,
    pricingEnabled: true,
    nftCollections: [],
    coins: [],
};

const coinSchema = yup.object().shape({
    coinName: yup.string().required('Coin name is required'),
    coinId: yup.string().required('Coin symbol is required'),
    minCoinBalance: yup
        .number()
        .typeError('Please enter a valid number')
        .required('Coin balance is required'),
});

export const generateValidationSchema = (maximumTicketsNumber: number, maximumPrice: number) => {
    return yup.object().shape({
        type: yup.string(),
        title: yup
            .string()
            .max(120, `Maximum length is ${120} characters.`)
            .required('Live Event title is a required field'),
        description: yup
            .string()
            .max(120, `Maximum length is ${250} characters.`)
            .required('Event description is a required field'),
        date: yup.date(),
        tickets: yup
            .number()
            .required('Tickets number is a required field')
            .typeError('This must be a valid number')
            .min(1, 'The minimum tickets number is 1')
            .max(maximumTicketsNumber, `The maximum tickets number is ${maximumTicketsNumber}`),
        price: yup
            .number()
            .typeError('This must be a valid number')
            .max(maximumPrice, `The maximum price is ${maximumPrice}`),
        pricingEnabled: yup.boolean(),
        coins: yup.array().when(['pricingEnabled', 'nftCollections'], {
            is: (pricingEnabled: boolean, nftCollections: string[]) =>
                !pricingEnabled && !nftCollections?.length,
            then: yup.array().of(coinSchema).min(1, 'Enter a NFT collection or a coin'),
        }),
    });
};
